<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { getRelativeTime } from '../utils';

  export let id;
  let q = null;
  let responses = [];
  let newResponse = '';
  let currentUser;
  let rewardAmount = 0; // For best answer
  
  authStore.subscribe(v => currentUser = v.user);

  onMount(fetchData);

  async function fetchData() {
      const res = await fetch(getApiUrl(`/qa/questions/${id}`));
      const data = await res.json();
      q = data.question;
      responses = data.responses;
  }

  async function submitResponse() {
      if(!newResponse) return;
      await fetch(getApiUrl('/qa/responses'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ questionId: id, userId: currentUser.idTokenClaims.oid, body: newResponse })
      });
      newResponse = '';
      fetchData();
  }

  async function markBest(rId) {
      const transfer = prompt("Optional: Enter amount of credits to reward (0 for none):", "0");
      if (transfer === null) return;
      
      const amount = parseInt(transfer) || 0;
      
      const res = await fetch(getApiUrl('/qa/best'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ questionId: id, responseId: rId, userId: currentUser.idTokenClaims.oid, transfer: amount })
      });
      
      if(res.ok) {
          alert("Marked as best!");
          fetchData();
      } else {
          const d = await res.json();
          alert(d.error);
      }
  }
</script>

<div class="container">
    {#if q}
        <div class="question-block">
            <h1>{q.title}</h1>
            <div class="meta">Asked by {q.userName} • {getRelativeTime(q.createdAt)}</div>
            <p class="body">{q.body}</p>
            {#if q.status === 'Solved'}
                <div class="badge-solved">✅ Solved</div>
            {/if}
        </div>

        <h3>{responses.length} Answers</h3>
        <div class="responses">
            {#each responses as r}
                <div class="resp-card {r.isBest ? 'best' : ''}">
                    <div class="r-header">
                        <strong>{r.userName}</strong>
                        <span class="date">{getRelativeTime(r.createdAt)}</span>
                    </div>
                    <p>{r.body}</p>
                    
                    {#if r.isBest}
                        <div class="best-badge">🏆 Best Answer {#if r.reward > 0}(+{r.reward} Credits){/if}</div>
                    {/if}
                    
                    {#if currentUser && currentUser.idTokenClaims.oid === q.userId && q.status === 'Open'}
                        <button class="mark-btn" on:click={() => markBest(r._id)}>Mark as Best</button>
                    {/if}
                </div>
            {/each}
        </div>

        {#if currentUser && q.status === 'Open'}
            <div class="reply-box">
                <h4>Your Answer</h4>
                <textarea bind:value={newResponse} rows="4"></textarea>
                <button on:click={submitResponse}>Submit Answer</button>
            </div>
        {/if}
    {:else}
        <p>Loading...</p>
    {/if}
</div>

<style>
    .container { max-width: 800px; margin: 2rem auto; padding: 1rem; }
    .question-block { background: white; padding: 2rem; border-radius: 8px; margin-bottom: 2rem; border: 1px solid #ddd; }
    .meta { color: #666; font-size: 0.9rem; margin-bottom: 1rem; }
    .body { font-size: 1.1rem; line-height: 1.6; }
    .badge-solved { display: inline-block; background: #e8f5e9; color: #2e7d32; padding: 5px 10px; border-radius: 15px; font-weight: bold; margin-top: 1rem; }

    .resp-card { background: white; padding: 1.5rem; margin-bottom: 1rem; border-radius: 8px; border: 1px solid #eee; }
    .resp-card.best { border: 2px solid #28a745; background: #f0fff4; }
    .r-header { display: flex; justify-content: space-between; margin-bottom: 0.5rem; }
    .date { color: #888; font-size: 0.8rem; }
    .best-badge { color: #28a745; font-weight: bold; margin-top: 0.5rem; }
    
    .mark-btn { background: #ffc107; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; font-size: 0.8rem; margin-top: 10px; }
    
    .reply-box textarea { width: 100%; padding: 1rem; margin: 1rem 0; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;}
    .reply-box button { background: #007bff; color: white; padding: 0.8rem 1.5rem; border: none; border-radius: 4px; cursor: pointer; }
</style>